import { Link } from 'react-router-dom';
import { Card, Skeleton } from '../../../ui';
import { formatNaira } from '../../../../utils/money';

const muted = 'text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor';

const BalanceCard = ({ title, caption, balance, loading, ledgerTo }) => (
  <Card
    title={title}
    className="mb-0"
    actions={caption && <span className={`text-sm ${muted}`}>{caption}</span>}
    footer={
      ledgerTo && (
        <Link to={ledgerTo} className="btn btn-link-primary btn-sm !px-0">
          View ledger
        </Link>
      )
    }
  >
    <p className="mb-0 text-f-h4 font-semibold text-theme-headings dark:text-themedark-headings">
      {loading ? <Skeleton w="70%" h="1.6rem" /> : formatNaira(balance)}
    </p>
  </Card>
);

export default BalanceCard;
